module.exports = __webpack_public_path__ + "img/dd1.ecaabba2.jpg";